export default __webpack_public_path__ + "static/media/background-small.be175a18.jpg";